import { Component } from '@angular/core';
import { ChartConfiguration } from 'chart.js';

@Component({
  selector: 'app-agent-analytics',
  templateUrl: './agent-analytics.component.html',
  styleUrls: ['./agent-analytics.component.css'],
})
export class AgentAnalyticsComponent {
  //Customer Engagement Line Chart Data

  public customerEngagementChartData: ChartConfiguration<'line'>['data'] = {
    labels: ['05:00', '10:00', '15:00', '20:00', '25:00', '30:00'],
    datasets: [
      {
        data: [0.1, 0.2, 0.3, 0.1, 0.2],
        label: 'Series B',
        borderColor: 'purple',
        backgroundColor: 'transparent',
        borderWidth: 4,
        tension: 0.4,
      },
    ],
  };

  //reseller Performance Bar Chart Data

  public resellerPerformanceChartData: ChartConfiguration<'bar'>['data'] = {
    labels: ['Service 1', 'Service 2', 'Service 3'],
    datasets: [
      { data: [3, 4.5, 7], label: 'Service A', backgroundColor: '#0058e9' },
    ],
  };

  //Scheme Participation Bar Chart Data

  public schemeParticipationChartData: ChartConfiguration<'bar'>['data'] = {
    labels: ['Error 1', 'Error 2', 'Error 3'],
    datasets: [
      { data: [3, 4.5, 7], label: 'Error A', backgroundColor: '#0058e9' },
    ],
  };

  //Support Request Bar Chart Data

  public supportRequestChartData: ChartConfiguration<'bar'>['data'] = {
    labels: ['Service 1', 'Service 2', 'Service 3'],
    datasets: [
      { data: [3, 4.5, 7], label: 'Service A', backgroundColor: '#0058e9' },
    ],
  };
}
